import { apiClient } from "../common/axiosInstance";

export const getAllTeams = async () => {
  const response = await apiClient.get("/areas");

  return response.data;
}